<script>
    import{user_data} from './stores.js';
    import { onMount } from "svelte";
    import Iqtemplate from "./components/iqtemplate.svelte";
    import Progresscomponent from "./components/progresscomponent.svelte";

    // let purchase_price = 300000;
    // let down_payment_amount = 60000;
    // let down_payment_percent = 20;
    // let credit_score;    

    // function doChangedCreditScore(evt) {
        
    // }

    // $: {
    //     if(credit_score !== undefined) $user_data.creditscore = credit_score;
    // }


</script>

<Iqtemplate
progress_mobile_version={true}
>
    <Progresscomponent 
    title="What's your estimated credit score?"
     >
    <div class="pricedpcontainer">
        <div class="commentcontainer">
            Your credit score helps us determine rates you qualify for.
        </div>
        <div class="creditscoreholder">
            <select bind:value={$user_data.creditscore} class="progressforminput">
                <option value="850">760 and above</option>
                <option value="759">740-759</option>
                <option value="739">720-739</option>
                <option value="719">700-719</option>
                <option value="699">680-699</option>
                <option value="679">660-679</option>
                <option value="659">640-659</option>
                <option value="639">620-639</option>
                <option value="619">600-619</option>
            </select>
        </div>
    </div>
    </Progresscomponent>

</Iqtemplate>

<style>
.pricedpcontainer {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.commentcontainer {
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 20px;
    color: var(--blueslate);
    font-size: 1em;
}
.creditscoreholder {
    width: 40%;
    margin-left: auto;
    margin-right: auto;
}
.creditscoreholder select{
    outline: none;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background: transparent;
    background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
    background-repeat: no-repeat;
    background-position-x: 100%;
    background-position-y: 5px;

}

.showmobile {
    display: none;
}

@media (max-device-width: 1024px), (max-width: 1023px) {
    .showdesktop {
        display: none;
    }
    .showmobile {
        display: block;
    }
    .creditscoreholder {
        width: 80%;
    }
    .creditscoreholder select {
        width: 100%;
    }   
}
</style>